export default __webpack_public_path__ + "static/media/work4.6bf9d98d.svg";